var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FormAddHomeAFY, ModalAFY, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
export var ModalAddHome = function (props) {
    return (_jsx(ModalAFY, __assign({ title: "Datos de la Propiedad", name: "", openModal: props.openModalAddHome, onClose: function () {
            props.setOpenModalAddHome(false);
        }, minWidthModal: "960px", heightModal: "340px", backgroundColor: "#FFFFFF", closeModalOutside: true }, { children: _jsx(FormAddHomeAFY, { section2Title: "Ubicaci\u00F3n de la propiedad", typeConstructionList: [
                {
                    id: "p1",
                    name: "Super_pro",
                    value: "p1",
                },
            ], dataForm: {
                ownerIdNumber: "132158-5465-5ddw-548",
                ownerName: "Negocio 1",
            }, onClickCancel: function () { return props.setOpenModalAddHome(false); }, onClickCalculateRate: function noRefCheck() { }, onNext: function noRefCheck() { }, showBtnCalcRate: true }) })));
};
